import { Component, Input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'tooltip',
    templateUrl: 'index.html'
})
export class TooltipComponent {
    @Input() text: string | undefined | null;
    @Input() setTextAsInnerHTML = false;
    @Input() position = 'right';
    @Input() show = false;
    @Input() positionX = 0;
    @Input() positionY = 0;
    @Input() horizontalOffset = 0;
    @Input() isDisabled: boolean;
    @Input() customClass = '';

    constructor(public sanitizer: DomSanitizer, private translate: TranslateService) {}

    public shouldDisplay() {
        return this.hasValidText() && !this.isDisabled;
    }
    private hasValidText(): boolean {
        return this.text !== undefined && this.text !== null && this.text.length > 0;
    }

    public getContentClasses(): string {
        return `tooltip-wrapper ${this.show ? 'show' : ''} ${this.customClass}`;
    }
}



// WEBPACK FOOTER //
// ./src/components/core/tooltip/index.ts